module.exports = __webpack_public_path__ + "static/media/25.4acad7a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/25.png
// module id = 878
// module chunks = 0